import React, { Component } from 'react';
import classNames from 'classnames';
import { Card, CardHeader, IconButton, Link } from '@material-ui/core';
import { red, green } from '@material-ui/core/colors';
import { Info as InfoIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

import { connect } from 'react-redux';

import { DragSource, DropTarget } from 'react-dnd';

import { ItemTypes } from '../../../config/constants';
import VirtualDransactionDuck from '../../../ducks/VirtualTransactionDuck';

const styles = (theme) => ({
  cardWrapper: {
    width: '100%',
  },
  card: {
    backgroundColor: theme.palette.background.paper,
  },
  cardDragging: {
    opacity: 0.5,
  },
  cardOver: {
    backgroundColor: green[100],
  },
  cardCantDrop: {
    backgroundColor: red[100],
  },
  transactionColumn: {
    position: 'relative',
  },
  transactionItem: {},
});

const walletCardSource = {
  beginDrag(props) {
    return {
      externalReferenceId: props.wallet.externalReferenceId,
    };
  },
};
function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}
const walletCardTarget = {
  canDrop(props, monitor) {
    const item = monitor.getItem();
    return item.externalReferenceId !== props.wallet.externalReferenceId;
  },
  drop(props, monitor, component) {
    const item = monitor.getItem();
    props.dispatch(
      VirtualDransactionDuck.creators.startVirtualTransaction(
        item.externalReferenceId,
        props.wallet.externalReferenceId,
      ),
    );
  },
};
function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

class WalletCard extends Component {
  state = {
    displayName: '',
  };

  componentDidMount() {
    this.setState({
      displayName:
        this.props.wallet.externalReferenceId || this.props.wallet.walletId,
    });
  }

  render() {
    const {
      wallet,
      classes,
      connectDragSource,
      isDragging,
      connectDropTarget,
      isOver,
      canDrop,
    } = this.props;
    return connectDropTarget(
      connectDragSource(
        <div className={classes.cardWrapper}>
          <Card
            className={classNames(
              classes.card,
              isDragging && classes.cardDragging,
              isOver && classes.cardOver,
              isOver && !canDrop && classes.cardCantDrop,
            )}
          >
            <CardHeader
              action={
                <Link
                  href={
                    'https://demowallet.trimplement.com/admin/wallets/' +
                    wallet.walletId
                  }
                  target="_blank"
                >
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </Link>
              }
              title={this.state.displayName}
            />
          </Card>
        </div>,
      ),
    );
  }
}

export default connect(
  null,
  null,
)(
  DropTarget(
    ItemTypes.WALLET_CARD,
    walletCardTarget,
    collectTarget,
  )(
    DragSource(
      ItemTypes.WALLET_CARD,
      walletCardSource,
      collectSource,
    )(withStyles(styles)(WalletCard)),
  ),
);
